/* eslint-disable react/jsx-no-target-blank */

import styles from "../home/Home.module.scss";
import { useEffect, useState } from "react";
import LandingPageLayout from "../../components/landingPageLayout";
import { FaArrowUp } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import First from "../landingpages/first/first";
import Second from "../landingpages/second/second";
import Third from "../landingpages/third/third";
import Four from "../landingpages/four/four";
import Five from "../landingpages/five/five";
import Six from "../landingpages/six/six";
import Seven from "../landingpages/seven/seven";
import Eight from "../landingpages/eight/eight";
import Video from "../landingpages/video/video";

export const Home = () => {
  const [open, setOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [expand, setExpand] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [showScroll, setShowScroll] = useState(false);

  // Function to update the state with the current screen width
  const updateScreenWidth = () => {
    setScreenWidth(window.innerWidth);
  };
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  // slider
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    afterChange: (index: any) => {
      // Update the active tab when the slider changes
      setActiveTab(index);
    },
    slidesToShow: 1,
    slidesToScroll: 1,
    // nextArrow: <CustomNextArrow />, // Use the custom component here
    // prevArrow: <CustomPrevArrow />,
  };

  // Add an event listener to update the width when the window is resized
  useEffect(() => {
    window.addEventListener("resize", updateScreenWidth);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", updateScreenWidth);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 425);
    };

    // Initial check for screen size on component mount
    handleResize();

    // Event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 100; // Adjust the scroll threshold as needed
      setShowScroll(isScrolled);
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    AOS.init({
      once: true,
    });
  }, []);

  return (
    <LandingPageLayout>
      <>
        {showScroll && open && (
          <div className={styles.scrollToTop} onClick={scrollToTop}>
            <FaArrowUp />
          </div>
        )}
        <First />
        <Second />
        <Third />
        <Four setOpen={setOpen} />
        {/* <Feature /> */}
        <Five />
        {/* <Video /> */}
        <Six />
        <Seven />
        <Eight />
      </>
    </LandingPageLayout>
  );
};
export default Home;
